export const VoucherRoutes = {
  path: "vouchers",
  name: "Vouchers",
  redirect: "/",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "add-vouchers-v2",
      name: "Add Vouchers",
      component: () => import("@/components/Pages/VouchersV2/addVouchersV2"),
    },
    {
      path: "edit-vouchers-v2/:voucher_id",
      name: "Edit Vouchers",
      component: () => import("@/components/Pages/VouchersV2/editVouchersV2"),
    },
    {
      path: "get-vouchers-v2",
      name: "Get Vouchers",
      component: () => import("@/components/Pages/VouchersV2/getVouchers"),
    },
    {
      path: "view-vouchers-codes/:voucher_id",
      name: "View Voucher Codes",
      component: () =>
        import("@/components/Pages/VouchersV2/viewVoucherCodesV2"),
    },
    {
      path: "view-vouchers-useage-v2",
      name: "View Voucher Codes",
      component: () =>
        import("@/components/Pages/VouchersV2/getVoucherUseageV2"),
    },
    {
      path: "add-vouchers-merch",
      name: "Add Vouchers Merch",
      component: () => import("@/components/Pages/MerchVouchers/addVouchersMerch"),
    },
    {
      path: "get-vouchers-merch",
      name: "Get Vouchers",
      component: () => import("@/components/Pages/MerchVouchers/getVoucherMerchandise"),
    },
    {
      path: "edit-vouchers-merch/:m_voucher_id",
      name: "Edit Vouchers",
      component: () => import("@/components/Pages/MerchVouchers/editVoucherMerchandise"),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/voucherRoutes.js